import { createSelector, Selector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import { AuthenticationState } from '../types'

const getFeatureState: Selector<ReduxState, AuthenticationState> = (state) => state.authentication

export const featureStateSelector = createSelector(getFeatureState, (state) => state)

export default featureStateSelector
